import { render, staticRenderFns } from "./Box3D.vue?vue&type=template&id=25e6a8d6&scoped=true&"
import script from "./Box3D.vue?vue&type=script&lang=ts&"
export * from "./Box3D.vue?vue&type=script&lang=ts&"
import style0 from "./Box3D.vue?vue&type=style&index=0&id=25e6a8d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e6a8d6",
  null
  
)

export default component.exports